import { useSyncExternalStore, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { automationReason, subscribeAutomation } from '../services/automation';
import { AlertIcon } from './Icons';

export function AutomationGuard({ children }: { children: ReactNode }) {
  const reason = useSyncExternalStore(subscribeAutomation, automationReason, () => null);
  const { t } = useTranslation('common');
  if (!reason) return children;
  return (
    <main className="automation-block" role="alert" aria-live="assertive">
      <div className="automation-block__panel">
        <span className="automation-block__icon" aria-hidden="true">
          <AlertIcon size={36} />
        </span>
        <h1 className="automation-block__title">{t('automation.title')}</h1>
        <p className="automation-block__text">{t('automation.body')}</p>
        <p className="automation-block__text">{t('automation.howTo')}</p>
        <p className="automation-block__warning">{t('automation.warning')}</p>
        <p className="automation-block__code">{t('automation.code', { reason })}</p>
        <button type="button" className="button" onClick={() => window.location.reload()}>
          {t('automation.reload')}
        </button>
      </div>
    </main>
  );
}
